export default [
  {
    path: '/admin/defines/interview-subjects',
    name: 'InterviewSubjects',
    component: () => import('@/views/Admin/Defines/Interview_subjects/Index.vue'),
    meta: {
      pageTitle: 'Görüşme Konuları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/interview-subjects/add',
    name: 'InterviewSubjectAdd',
    component: () => import('@/views/Admin/Defines/Interview_subjects/Add.vue'),
    meta: {
      pageTitle: 'Görüşme Konuları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/interview-subjects',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/interview-subjects/edit/:id',
    name: 'InterviewSubjectEdit',
    component: () => import('@/views/Admin/Defines/Interview_subjects/Edit.vue'),
    meta: {
      pageTitle: 'Görüşme Konuları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/interview-subjects',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
